import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useState } from "react";

import { StoreProps } from "@/reducers/storeReducer/storeTypes";

import useClickOutside from "../../../../hooks/useClickOutside/useClickOutside";
import Modal from "../../../General/Modal/Modal";
import { MgtStoreDto } from "@/api/swagger";

type Props = {
  stores: Array<StoreProps | MgtStoreDto>;
  onChange: (id: number) => void;
  value: number | null;
  close: () => void;
};

const StoreSelector: React.FC<Props> = ({ stores, onChange, value, close }) => {
  const [ref, setRef] = useState<HTMLElement | null>(null);

  useClickOutside(ref, close);

  return (
    <Modal>
      <div ref={setRef} className="storeSelector">
        <h3 className="heading__name storeSelector__heading">選擇分店</h3>
        <ul className="storeSelector__list">
          {stores.map((store) => {
            const isSelected = store.id === value;
            return (
              <li
                key={store.id}
                className={`storeSelector__item body ${
                  isSelected ? "selected" : ""
                }`}
                onClick={() => onChange(store.id)}
              >
                {store.name}
                {isSelected && <FontAwesomeIcon icon={["far", "check"]} />}
              </li>
            );
          })}
        </ul>
      </div>
    </Modal>
  );
};

export default StoreSelector;
